module.exports = __webpack_public_path__ + "static/media/CoreLogo.ed121ac5.png";